import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  I18NextTranslationPaths,
  I18NextValues,
} from "@dfp/isomorphic-typed-translations";

export function useGenericTT<T>(projectName: string, translations: T) {
  const { t, i18n } = useTranslation(projectName);

  return useMemo(
    () => ({
      tt: (
        path: I18NextTranslationPaths<typeof translations>,
        values?: I18NextValues,
      ) => t(path, { ...values, ns: projectName }), // ns is explicitly set for the second time because of Trans components
      ttObject: <T = unknown>(path: string, values?: I18NextValues): T =>
        t(path, { ...values, returnObjects: true }) as T,
      language: i18n.language,
    }),
    [t, i18n.language, projectName],
  );
}
